module.exports = __webpack_public_path__ + "static/media/loscabos.87dcf946.jpg";